import React, { Component } from 'react';
import kassaLogo from '../images/kassa-logo.svg';
import {Sidebar, Menu, Icon} from 'semantic-ui-react';



class Header extends Component {
    state ={
        menuVisible:false
    }
    render() {
        return (
                <div className="header" id="header">
			
                    <div className="logo">
                        <a href="http://www.kassa.co/"><img src={kassaLogo} alt="Kassa" title="Kassa" className="kassalogo"/></a>
                    </div>
                    <ul id="language">
                        <li data-menuanchor="nasilcalisir"><a href="#" >Nasıl Çalışır?</a></li>
                        <li data-menuanchor="cuzdan"><a href="/help/Faq">FAQ</a></li>
                        <li data-menuanchor="yardim"><a href="/help/Support">Destek</a></li>
                        <li data-menuanchor="download"><a href="http://www.kassa.co/download.html" target="_blank" className="downloadKassa">Kassa’yı İndir</a></li>
                        <li><a href="#" className="kassaWeb">Kassa Web</a></li>
                    </ul>
                    <ul className="burger" onClick={()=>{this.setState({menuVisible:true})}}>
                        <img src={require('../images/open.svg')}/>
                    </ul>
                    <Sidebar
                        as={Menu}
                        animation='overlay'
                        direction='right'
                        icon='labeled'
                        vertical
                        visible={this.state.menuVisible}
                        width='wide'
                        className='sideMenu'
                    >
                        <div>
                            <div className="menuHeader">
                               <img src={require('../images/close.svg')} onClick={()=>{this.setState({menuVisible:false})} }/>   
                            </div>
                            <div>
                            <div className="menuContent">
                                <a href="#" >Nasıl Çalışır?</a>
                                <a href="/help/Faq">FAQ</a>
                                <a href="/help/Support">Destek</a>
                                <a href="http://www.kassa.co/download.html" target="_blank" className="downloadKassa">Kassa’yı İndir</a>
                                <a href="#" className="kassaWeb">Kassa Web</a>
                            </div>
                            </div>
                        </div>
                    </Sidebar>
	            </div>
        )
    }
}
export default Header